import { ReactNode, useId } from "react";
import cx from "classnames";

import styles from "./styles.module.css";
import Segment from "./Segment";
import Box, { BoxProps } from "../Box";

export type SegmentedControlOption<T extends string> = {
  label: ReactNode;
  value: T;
  disabled?: boolean;
  tooltip?: ReactNode;
};

export type SegmentedControlProps<T extends string> = {
  options: SegmentedControlOption<T>[];
  value: T;
  onChange: (value: T) => void;
  size?: "small" | "medium";
  margin?: BoxProps["margin"];
  className?: string;
  optionClassName?: string;
};

function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  size,
  margin,
  className,
  optionClassName,
}: SegmentedControlProps<T>) {
  const controlName = useId();

  return (
    <Box
      className={cx(styles.wrapper, size === "small" && styles.small, className)}
      margin={margin}
      shrink="0"
    >
      {options.map((option) => (
        <Segment
          className={optionClassName}
          key={option.value}
          controlName={controlName}
          label={option.label}
          value={option.value}
          selected={option.value === value}
          onChange={onChange}
          disabled={option.disabled}
          tooltip={option.tooltip}
        />
      ))}
    </Box>
  );
}

SegmentedControl.displayName = "DS.SegmentedControl";

export default SegmentedControl;
